import store from '@/store'
// import { get } from 'lodash'
import securePaymentStatusConfig, {
  disputedStatusConfig,
  securePaymentStatus,
  securePaymentStates,
  securePaymentDisputeStates,
  statusClasses
} from '@/lib/mapping/secure-payments-status'
import dayjs from 'dayjs'

// We need to make the model consistant at all times and we need to fill in some additional front end flags and make the
// data generally easier to work with across components
const securePaymentsFillModel = transaction => {
  let app = store.getters['app/getApp']

  // We've already filled this transaction
  if (transaction.statusId) {
    return transaction
  }

  let data = { ...transaction }

  data.statusId = 1
  data.disputeStatusId = 0

  data.isCancelled = [securePaymentStatus.WITHDRAWN, securePaymentStatus.CANCELLED].includes(data.status)

  data.isDisputed = data.status === securePaymentStatus.DISPUTED || !!data.disputeBuyerComment

  data.isBuyer = transaction.buyer.user[0].userRef === app.user.userRef
  data.isSeller = transaction.seller.user[0].userRef === app.user.userRef

  data.otherPartyKey = data.isBuyer ? 'seller' : 'buyer'
  data.userPartyKey = data.isBuyer ? 'buyer' : 'seller'
  data.otherParty = data[data.otherPartyKey]
  data.userParty = data[data.userPartyKey]

  data.isInitiator = transaction.createdByUserRef === app.user.userRef

  if (data.buyerPaid === 1) {
    data.statusId = securePaymentStates.AWAITING_CONFIRM_MOVEMENT
  }

  if (data.sellerReleaseItems === 1) {
    data.statusId = securePaymentStates.AWAITING_RELEASE_FUNDS
  }

  if (data.buyerReceivedItems === 1) {
    data.statusId = securePaymentStates.RELEASING_FUNDS
  }

  if (data.isCancelled && data.buyerPaid === 0) {
    data.statusId = securePaymentStates.CANCELLED_BEFORE_FUNDING
  }

  if (data.isCancelled && data.buyerPaid === 1) {
    data.statusId = securePaymentStates.CANCELLED_AFTER_FUNDING
  }

  // Disputes
  if (data.disputeBuyerComment) {
    data.disputeStatusId = securePaymentDisputeStates.ACTIVE
  }

  if (data.refunds.length) {
    data.statusId = securePaymentStates.REFUND_IN_PROGRESS
  }

  if (data.refundTotal) {
    data.disputeStatusId = securePaymentDisputeStates.RESOLVED
    data.isDisputed = false
    data.hasRefund = true
    data.statusId = securePaymentStates.RELEASING_FUNDS
  }

  if (data.refunds?.[0]?.refundManualRefundedDate) {
    data.statusId = securePaymentStates.REFUND_COMPLETE

    if (data.paymentPayoutDate && data.paymentPayoutDate === '0000-00-00 00:00:00') {
      data.statusId = securePaymentStates.RELEASING_FUNDS
    }
  }

  if (data.paymentPayoutDate && data.paymentPayoutDate !== '0000-00-00 00:00:00') {
    data.statusId = securePaymentStates.PAYMENT_COMPLETE
  }

  // Either party can cancel if no payment has been made
  data.isAbleToCancel = data[`${data.userPartyKey}CanCancel`] === 1

  data.isAbleToRequestInvoice = !data.isCancelled && data.statusId >= securePaymentStates.AWAITING_CONFIRM_MOVEMENT

  data.isVerified = true
  data.isActionRequired = false
  data.isComplete =
    data.status === securePaymentStatus.COMPLETED ||
    (data.isBuyer && data.statusId >= securePaymentStates.RELEASING_FUNDS)

  data.updatedTimestamp = dayjs(transaction.updatedDate, 'DD-MM-YYYY HH:mm:ss').valueOf()

  // TODO: Remove once all references in templates have been removed
  data.trueLayerStatus = null
  data.isPaidIn = data.statusId > securePaymentStates.AWAITING_PAYMENT

  data.totalAmountSellerReceives = data.balance

  // Is this transaction waiting on us?
  if (!data.isCancelled) {
    if (
      securePaymentStatusConfig[data.statusId].actionRequired === data.userPartyKey ||
      (data.statusId === securePaymentStates.AWAITING_ACCEPTANCE && !data.isInitiator) ||
      (data.disputeStatusId > 0 && disputedStatusConfig[data.disputeStatusId].actionRequired === data.userPartyKey)
    ) {
      data.isActionRequired = true
    }
  }

  data.tagClass = data.isActionRequired ? statusClasses.danger : securePaymentStatusConfig[data.statusId].tagClass

  // Hardcoded for now
  data.currencyCode = 'GBP'

  if (data.isDisputed) {
    data.statusLabel = disputedStatusConfig[data.disputeStatusId][data.userPartyKey].statusLabel
    data.statusTitle = disputedStatusConfig[data.disputeStatusId][data.userPartyKey].title
  } else {
    data.statusLabel = securePaymentStatusConfig[data.statusId][data.userPartyKey].statusLabel
    data.statusTitle = securePaymentStatusConfig[data.statusId][data.userPartyKey].title
  }

  // if (data.isDisputed && data.dispute.status !== securePaymentDisputeStates.RESOLVED) {
  //   data.statusTitle = disputedStatus[data.dispute.status][data.userPartyKey].title
  //   data.status = disputedStatus[data.dispute.status][data.userPartyKey].status
  // }

  // If cancelled, overwrite all other titles
  if (data.isCancelled) {
    data.statusTitle = 'Transaction Cancelled'
    data.statusLabel = 'Cancelled'
  }

  const currentPartyCommissionPercentage = data.isBuyer
    ? data.buyerCommission || 0
    : data.commission || data.sellerCommission || 0
  const currentPartyFeeExcludingVATAmount = currentPartyCommissionPercentage
    ? Number(((currentPartyCommissionPercentage / 100) * data.total).toFixed(2))
    : 0

  const currentPartyFeeIncludingVATAmount = currentPartyFeeExcludingVATAmount * 0.2

  // This is only valid BEFORE refunds, e.g during buyer pay in stage
  data.buyerTotalToPayIn = data.total + currentPartyFeeExcludingVATAmount + currentPartyFeeIncludingVATAmount

  // TODO: Finish adding all the non-active states
  data.isActive = data.status === securePaymentStatus.LIVE

  // Users are able to review each other once we have moved past releasing funds
  data.isAbleToLeaveReview = data.statusId > securePaymentStates.AWAITING_RELEASE_FUNDS && !data.isCancelled

  return data
}

export default securePaymentsFillModel
